// ---------------------------------------------------------------------------
// Reancoramento do lote de velas (fatiador)
//
// O fatiador entrega ao terminal um lote (janela) de velas e o terminal desloca o
// grupo 3D por (offset atual - offset do lote) velas, mantendo cada vela parada na
// posição correta enquanto o lote é trocado a cada ~100 velas navegadas.
//
// Para a troca ser invisível, o deslocamento de um grupo só pode usar o offset do
// MESMO lote que está desenhado naquele grupo. Os grupos da parede usam uma cópia
// "adiada" dos dados (React.useDeferredValue); por isso eles precisam de uma cópia
// adiada do offset do lote também (veja SceneContent.tsx).
// ---------------------------------------------------------------------------

/**
 * Deslocamento (em velas) do grupo: offset atual - offset do lote, limitado às sobras do lote.
 * F2: `currentOffset` e `batchOffset` são distâncias do fim RELATIVAS À MESMA SÉRIE (a do lote): a posição vem de
 * `positionFor(historyOffsetRef, lote.newestAbs)` (anchoredNav.ts), nunca de uma distância global.
 */
export function computeSliceShift(currentOffset: number, batchOffset: number, padLeft: number, padRight: number): number {
  const raw = Math.max(0, currentOffset) - batchOffset;
  return Math.min(padLeft, Math.max(-padRight, raw));
}
